// react imports
import React from "react";

// package imports
import { observer } from "mobx-react";

import { BottomsheetDropdown } from "components";
// project imports



const ActivePensionPlus = ({ form, data }) => {


  return (
    <div className=''>
      <div className='my-4  mx-0'>
        {/* <Col xs={12} md={6} className='mb-3'> */}
        {/* <p className='mb-2 font-size-12 font-weight-light '>{form.$("policy-term").label}</p> */}
        <BottomsheetDropdown
          dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
          menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
          menuItemStyle='d-flex justify-content-between align-items-center'
          selectedLabelKey='label'
          bottomsheetTitle={form.$("policy-term").label}
          menuList={form.$("policy-term").extra.optionList}
          value={form.$("policy-term").value}
          onSelect={form.$("policy-term").onChange}
          disabled={form.$("policy-term").disabled}
        />
        {/* </Col> */}
      </div>
      <div className="my-4  mx-0">
      {/* <Col xs={12} md={6} className='mb-3'> */}
        {/* <p className='mb-2 font-size-12 font-weight-light '>{form.$("premium-term").label}</p> */}
        <BottomsheetDropdown
          dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
          menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
          menuItemStyle='d-flex justify-content-between align-items-center'
          selectedLabelKey='label'
          bottomsheetTitle={form.$("premium-term").label}
          menuList={form.$("premium-term").extra.optionList}
          value={form.$("premium-term").value}
          onSelect={form.$("premium-term").onChange}
          disabled={form.$("premium-term").disabled}
        />
      {/* </Col> */}
    </div>
    </div >
  );
};

export default observer(ActivePensionPlus);
